$(function (){
    $(document).on("click", ".page-link:not('.active')", function(){
        let $this = $(this),
            input = $(document).find('[data-input=customers--search]').val(),
            page = $this.attr("data-page"),
            data_what = $this.attr("data-what"),
            id = $this.parents(".content--wrapper").attr("data-id");
        switch (data_what){
            case "licenses":
                getCustomers(input, page);
                break;
        }
    })
})